import React, { Component } from 'react'
import styles from './MagazinePreview.scss'
import { CompactPicker } from 'react-color'
import { connect } from 'react-redux'
import { setHeaderMode } from '@/store/actions'
import { getLanguageKeys } from '@/store/getters'
import { MagazinesResource } from '@/resources'
import { withTurnPagePlugin } from '@/hocs/withTurnPagePlugin'
import { RenderMagazine } from '../RenderMagazine'
import { configurePreview } from '@/utils/configurePreview'
import UploadImage from '@/components/fileManager/UploadImage'
import { defaultPageSize, pageSizeFromProperties } from "../../../utils/pageSize";

class MagazinePreview extends Component {
  constructor(props) {
    super(props)
    this.state = {
      actualPage: 0,
      pages: [],
      pageStyle: {},
      pageSize: defaultPageSize,
      background: {
        backgroundColor: '#fff'
      },
      standAlone: this.props.location.search.indexOf('standalone') !== -1,
      scaleFactor: 1,
      start: false
    }
    this.containerRef = null
    this.pagesPreview = null
    this.onPressEsc = this.onPressEsc.bind(this)
    this.onChangeColor = this.onChangeColor.bind(this)
    this.onChangeImage = this.onChangeImage.bind(this)
    this.navPage = this.navPage.bind(this)
    this.setRef = this.setRef.bind(this)
  }

  async componentDidMount() {
    const {
      params: { magazineId }
    } = this.props.match
    await this.backgroundPage(magazineId)

    if (this.state.standAlone) {
      this.props.setHeaderMode('hidden')
    } else {
      this.props.setHeaderMode('preview')
    }

    configurePreview(this.state, this.containerRef, state => {
      this.setState(state, () => this.startTurnPage())
    })


    document.addEventListener('click', this.onGoPage)

    /** inicio da gambi pra resolver problema de scroll devido a lib */

    // const cssBA = document.getElementById('css-builderall-lib')
    // const jsBA = document.getElementById('js-builderall-lib')

    // if (cssBA) cssBA.remove()
    // if (jsBA) jsBA.remove()

    /** fim da gambi pra resolver problema de scroll devido a lib */
  }

  /**
   * Remove event listener from function
   */
  componentWillUnmount() {
    document.removeEventListener('click', this.onGoPage)
  }


  /**
   * Create turn for the page
   * @param {Object} e
   */
  onGoPage = e => {
    const getAttributeHref = e.target.closest('a') && e.target.closest('a').getAttribute('href')

    if (!getAttributeHref || getAttributeHref.indexOf('#page') === -1) return false

    e.preventDefault()

    const goPage = getAttributeHref.replace('#page-', '')
    this.props.$('#pages').turn('page', goPage)
  }

  onPressEsc(e) {
    if (e.which === 27) {
      this.props.history.goBack()
    }
  }

  startTurnPage() {
    const { pageSize } = this.state
    this.props
      .$('#pages')
      .turn(
        {
          display: 'double',
          width: pageSize.width * 2,
          height: pageSize.height,
          elevation: 0,
          gradients: true,
          autoCenter: true
        },
        {
          cornerSize: 300
        }
      )
      .bind('turning', (e, page) => {
        this.setState({
          actualPage: page
        })
      })
      this.setState({start: true})
  }

  /**
   * Background Color
   * @param {String} color
   */
  onChangeColor(color) {
    const backgroundColor = { backgroundColor: color }

    this.setState({ background: backgroundColor })
    this.onSaveProps(backgroundColor)
  }

  /**
   * Background Image
   * @param {Object} data
   */
  onChangeImage(src) {
    const backgroundImage = {
      backgroundImage: `url(${src})`,
      backgroundSize: 'cover'
    }

    this.setState({ background: backgroundImage })
    this.onSaveProps(backgroundImage)
  }

  async backgroundPage(magazineId) {
    const { data: magazine } = await MagazinesResource.getById(magazineId)

    const properties = JSON.parse(magazine.properties)

    if (!!properties) this.setState({
      background: properties,
      pageSize: pageSizeFromProperties(properties)
    })
  }

  /**
   * SAVE A PROPS PREVIEW
   * @param {Object} background
   */
  onSaveProps(background) {
    const {
      params: { magazineId }
    } = this.props.match

    const { pageSize } = this.state

    MagazinesResource.update(
      {
        properties: JSON.stringify({ ...background, pageSize })
      },
      magazineId
    )
  }

  navPage(direction) {
    this.props.$('#pages').turn(direction)
  }

  setRef(ref) {
    this.containerRef = ref
  }

  render() {
    const { background, actualPage, standAlone, scaleFactor, start } = this.state
    const { locales, pages } = this.props

    return (
      <div className={styles['magazines-preview']}>
        {!standAlone && (
          <aside className={styles.toolbar}>
            <h4>{locales['general-background-color']}</h4>
            <CompactPicker
              color={background['backgroundColor']}
              onChangeComplete={({ hex }) => this.onChangeColor(hex)}
            />
            <h4>{locales['general-background-image']}</h4>
            <UploadImage
              text={locales['image-select']}
              onImageSended={this.onChangeImage}
            />
          </aside>
        )}

        <RenderMagazine
          pages={pages}
          background={background}
          actualPage={actualPage}
          onNavigation={this.navPage}
          setRef={this.setRef}
          scaleFactor={scaleFactor}
          start={start}
        />
      </div>
    )
  }
}
const mapStateToProp = state => {
  const locales = getLanguageKeys(state)
  return {
    locales
  }
}
export default withTurnPagePlugin(
  connect(
    mapStateToProp,
    { setHeaderMode }
  )(MagazinePreview)
)



// WEBPACK FOOTER //
// ./src/components/publish/preview/MagazinePreview.js